export const roles = [
  {
    code: 1,
    key: 'admin',
    name: 'Administrador',
    implemented: false,
    root: false
  },
  {
    code: 2,
    key: 'driver',
    name: 'Conductor',
    implemented: true,
    root: false
  },
  {
    code: 3,
    key: 'warehouse_scan',
    name: 'Bodega',
    implemented: false,
    root: false
  },
  {
    code: 4,
    key: 'assistant',
    name: 'Asistente',
    implemented: false,
    root: false
  },
  {
    code: 5,
    key: 'driver_last_mile',
    name: 'Conductor - Ultima Milla',
    implemented: true,
    root: false
  },
  {
    code: 6,
    key: 'admin_last_mile',
    name: 'Administrador - Ultima Milla',
    implemented: true,
    root: false
  },
  {
    code: 7,
    key: 'admin_consolidated',
    name: 'Administrador CD',
    implemented: true,
    root: false
  },
  {
    code: 8,
    key: 'warehouse_guy',
    name: 'Bodega',
    implemented: false,
    root: false
  },
  {
    code: 9,
    key: 'assistant_picking',
    name: 'Asistente Picking',
    implemented: false,
    root: false
  },
  {
    code: 10,
    key: 'root',
    name: 'Super Administrador',
    implemented: true,
    root: true
  },
  {
    code: 11,
    key: 'finance',
    name: 'Finanzas',
    implemented: true,
    root: false
  },
  {
    code: 12,
    key: 'user_client',
    name: 'Cliente',
    implemented: true,
    root: false
  },
  {
    code: 13,
    key: 'admin_finance',
    name: 'Administrador Finanzas',
    implemented: true,
    root: false
  },
  {
    code: 14,
    key: 'operator',
    name: 'Operador',
    implemented: true,
    root: false
  },
  {
    code: 15,
    key: 'supervisor',
    name: 'Supervisor',
    implemented: true,
    root: false
  },
  {
    code: 16,
    key: 'client_service',
    name: 'Servicio al cliente',
    implemented: true,
    root: false
  },
  {
    code: 17,
    key: 'kam',
    name: 'KAM',
    implemented: true,
    root: false
  },
  {
    code: 18,
    key: 'coordinator',
    name: 'Coordinador',
    implemented: true,
    root: false
  }
];

/**
 * Get role type by code
 * @param {*} Key key to find code of type
 */
export const getRole = key => {
  const role = roles.find(e => e.key === key);
  if (!role) {
    return {
      code: '999',
      key: 'UNKNOWN_STATUS'
    };
  }
  return role;
};

/**
 * Get roles implemented
 */
export const getRoleImplemented = thisRole => {
  if (thisRole === getRole('root').code) {
    return roles.filter(
      e =>
        e.implemented &&
        isRoleAuthorized(e.code, [
          'driver',
          'driver_last_mile',
          'admin_last_mile',
          'admin_consolidated',
          'finance',
          'user_client',
          'operator',
          'supervisor',
          'client_service',
          'kam',
          'coordinator'
        ])
    );
  }
  if (thisRole === getRole('admin_consolidated').code) {
    return roles.filter(
      e =>
        e.implemented &&
        isRoleAuthorized(e.code, [
          'driver',
          'admin_consolidated',
          'assistant_picking',
          'operator',
          'supervisor',
          'client_service'
        ])
    );
  }
  if (thisRole === getRole('admin_last_mile').code) {
    return roles.filter(
      e =>
        e.implemented &&
        isRoleAuthorized(e.code, ['driver_last_mile', 'admin_last_mile'])
    );
  }
  if (thisRole === getRole('finance').code) {
    return roles.filter(
      e =>
        e.implemented &&
        isRoleAuthorized(e.code, ['driver_last_mile', 'driver'])
    );
  }
  if (thisRole === getRole('supervisor').code) {
    return roles.filter(
      e =>
        e.implemented &&
        isRoleAuthorized(e.code, ['driver_last_mile', 'driver', 'operator'])
    );
  }
  // default, no roles available
  return [];
};

export const isRoleAuthorized = (thisRole, authorizedRoles) => {
  const targetCode = Number.isInteger(thisRole)
    ? thisRole
    : getRole(thisRole).code;
  const isAuthorized = authorizedRoles.find(
    e => getRole(e).code === targetCode
  );
  if (isAuthorized) {
    return true;
  }
  return false;
};
